import classnames from 'classnames';

import './AnchorButton.scss';
import useAnchorButton from './useAnchorButton';

const AnchorButton = ({ scrollRef, pageName, eventName, customLink }) => {
  const { isVisible, handleClick } = useAnchorButton({
    scrollRef,
    pageName,
    eventName,
    customLink,
  });

  return (
    <div
      className={classnames('anchor-button', {
        'anchor-button--visible': isVisible,
      })}
    >
      <button
        className="ids-main-button ids-main-button--full"
        onClick={handleClick}
      >
        <span className="ids-main-button__content">Abrir conta</span>
      </button>
    </div>
  );
};

export default AnchorButton;
